export default __webpack_public_path__ + "static/media/whatsapp.20ab485e.png";